import { CSSProperties, PureComponent } from "react";
import { MiddleTruncate } from "../../../shared/utility/middle-truncate";
import "./kuika-tag.scss";

interface IKuikaTagProps {
  label: string;
  type: "action" | string;
  style?: CSSProperties;
  // Forwarded to the rendered chip so callers can expose a stable test hook
  // instead of leaning on the `kuika-tag__<type>` class.
  dataTestId?: string;
  // "middle" lets the chip shrink and clips a label that does not fit in its middle ("#K…A16209KEY1").
  // Tags that share a prefix, such as two bag keys, differ only at the end, which a plain ellipsis cuts off.
  truncate?: "middle";
}

interface IKuikaTagState {}

export class KuikaTag extends PureComponent<IKuikaTagProps, IKuikaTagState> {
  constructor(props: IKuikaTagProps) {
    super(props);
  }

  getClassName = () => {
    const { type, truncate } = this.props;
    let className = "kuika-tag";

    if (type) {
      className += ` kuika-tag__${type}`;
    }

    if (truncate === "middle") {
      className += " kuika-tag--truncate-middle";
    }

    return className;
  };

  render() {
    const text: string = `#${this.props.label}`;
    return (
      <div className={this.getClassName()} style={this.props.style} data-testid={this.props.dataTestId}>
        {this.props.truncate === "middle" ? <MiddleTruncate text={text} /> : text}
      </div>
    );
  }
}
